import React from "react";
import PageHeader from "./PageHeader";
import "../css/product.css";

const Products = () => {
    return (
        <div>
            <PageHeader eyebrow="Products" title="Software we build and run">
                Ready-to-use AI tools that help online sellers understand their customers and keep track of their money.
            </PageHeader>

            <div className="page section">
                {/* Comment IQ */}
                <article id="commentIQ" className="feature">
                    <div className="feature-media">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/Sentiment.png`}
                            alt="Comment IQ sentiment analysis"
                        />
                    </div>
                    <div className="feature-body">
                        <h2>Comment IQ</h2>
                        <div className="tags">
                            <span className="tag">Instagram</span>
                            <span className="tag">Facebook</span>
                        </div>
                        <p>
                            Comment IQ analyzes the comments on your Instagram and Facebook posts, identifying positive and negative sentiment. But what sets Comment IQ apart is its ability to detect special requests hidden within those comments, a game-changer for sellers.
                        </p>
                        <p>
                            Imagine instantly knowing if a potential customer has asked for a specific color, size or customization. Comment IQ surfaces these details, so you can offer personalized service, meet unique needs and drive sales directly from your social media posts.
                        </p>
                        <p className="product-tagline">Don't just read comments – understand them with Comment IQ.</p>
                        <a
                            href="https://commentiq.manvidia.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn"
                        >
                            Get the App <span aria-hidden="true">↗</span>
                        </a>
                    </div>
                </article>

                {/* ReconIQ */}
                <article id="reconIQ" className="feature feature--reverse">
                    <div className="feature-media">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/ReconIQ.svg`}
                            alt="ReconIQ payment reconciliation"
                        />
                    </div>
                    <div className="feature-body">
                        <h2>ReconIQ</h2>
                        <div className="tags">
                            <span className="tag">Amazon</span>
                            <span className="tag tag-muted">Flipkart · coming soon</span>
                        </div>
                        <p>
                            Did the marketplace pay you everything you're owed? ReconIQ answers that question for every order. It connects securely to your seller account and reconciles each order against the marketplace's transaction records and settlement reports, accounting for fees, taxes, refunds and advertising spend.
                        </p>
                        <p>
                            Every order is marked as matched, showing a variance, unsettled, overdue or awaiting a refund, so missing payouts and unexpected deductions stand out instead of hiding in spreadsheets. ReconIQ also brings together your GST tax reports and advertising performance, including ACoS and TACoS, and lets you export any report to CSV.
                        </p>
                        <p className="product-tagline">Stop guessing where your money went. Know it with ReconIQ.</p>
                        <a
                            href="https://reconiq.manvidia.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn"
                        >
                            Get the App <span aria-hidden="true">↗</span>
                        </a>
                    </div>
                </article>
            </div>
        </div>
    );
};

export default Products;
